import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { arriveAppointment } from "../../api";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import { FaTimes } from "react-icons/fa";
import logo from "../../Resources/Transparent_Logo.png";

export default function CheckIn() {
  // Practice IDs
  const [errorAlert, setErrorAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [start, setStart] = useState(() => {
    // Get current time and adjust to SAST
    const now = new Date();
    const localOffset = now.getTimezoneOffset() * 60000; // Offset in milliseconds
    const southAfricaTime = new Date(now.getTime() - localOffset);
    console.log("noslice", southAfricaTime);
    return southAfricaTime.toISOString().slice(0, 16); // Display in datetime-local format
  });

  const { practiceNumbers } = useParams();
  const practiceNumbersArray = practiceNumbers.split(",");

  const [data, setData] = useState({
    patientIdNumber: "",
    patientLastName: "",
    start: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "start") {
      const isoValue = `${value}`; // Add seconds for ISO format
      const inputDate = new Date(isoValue);

      if (isNaN(inputDate.getTime())) {
        console.error("Invalid date value:", isoValue);
        return;
      }

      setStart(isoValue);
      setData((prevData) => ({
        ...prevData,
        patientIdNumber: data.patientIdNumber,
        patientLastName: data.patientLastName,
        practiceId: practiceNumbersArray,
        start: isoValue,
      }));
    } else {
      setData((prevData) => ({ ...prevData, [name]: value }));
    }
    setErrorAlert(false);
    setSuccessAlert(false);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // One call: the kiosk proves who the patient is and the server marks
      // them arrived. Previously this looked the appointment up and then hit
      // the general status endpoint, which had to stay open to the internet
      // for the kiosk's sake.
      const response = await arriveAppointment(data);

      if (response?.found) {
        setSuccessAlert(true);
      } else {
        setErrorAlert(true);
      }
    } catch (error) {
      console.error("Error during check-in:", error);
      setErrorAlert(true);
      console.log("data", data);
    }
  };

  // Close alerts
  const handleCancelClose = () => {
    setErrorAlert(false);
    setSuccessAlert(false);
    setData({
      patientIdNumber: "",
      patientLastName: "",
      start: "",
      practiceNumber: "",
    });
  };

  return (
    <div className="w-100 container mt-3 pt-3">
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        // Optional: Adjust height as needed
      >
        <img src={logo} alt="Logo" style={{ width: "100px", height: "80px" }} />
        <h4 className="mt-4 text-primary">Check In</h4>
        <p className="fw-light fs-sm">
          Please enter the information below and submit, to check-in for your
          appointment
        </p>
        {errorAlert && (
          <Alert
            variant="danger"
            className="w-100 d-flex align-items-center justify-content-between"
          >
            <span>
              No matching appointment found, please check-in at Reception.
            </span>
            <Button
              className="text-black bg-transparent fs-6 border border-color-transparent"
              onClick={handleCancelClose}
            >
              <FaTimes />
            </Button>
          </Alert>
        )}

        {successAlert && (
          <Alert
            variant="success"
            className="w-100 d-flex align-items-center justify-content-between"
          >
            <span>You have checked-in for your appointment successfully</span>
            <Button
              className="text-black bg-transparent fs-6 border border-color-transparent"
              onClick={handleCancelClose}
            >
              <FaTimes />
            </Button>
          </Alert>
        )}
      </div>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Form.Group as={Col} controlId="idNumber">
            <Form.Label>Patient ID Number</Form.Label>
            <Form.Control
              required
              name="patientIdNumber"
              value={data.patientIdNumber}
              onChange={handleChange}
            />
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} controlId="lastName">
            <Form.Label>Patient Last Name</Form.Label>
            <Form.Control
              required
              name="patientLastName"
              value={data.patientLastName}
              onChange={handleChange}
            />
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group controlId="appointmentStart">
            <Form.Label>Start</Form.Label>
            <Form.Control
              type="datetime-local"
              name="start"
              value={start} // Display in datetime-local format
              onChange={handleChange}
              style={{
                backgroundColor: "#ffffff",
                color: "#212529",
                cursor: "text",
              }}
            />
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <div className="d-flex justify-content-center">
            <Button variant="primary" type="submit" className="pe-3 w-25">
              Check In
            </Button>
          </div>
        </Row>
      </Form>
    </div>
  );
}
